export const validateEmail = email => {
  let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email) || "Invalid e-mail.";
};

const requiredCheck = (value, hint) => !!value || hint;

export const firstNameRule = [
  v => requiredCheck(v, "Please enter your first name")
];
export const lastNameRule = [
  v => requiredCheck(v, "Please enter your last name")
];
export const emailAddressRule = [
  v => requiredCheck(v, "Please enter your Email Address"),
  validateEmail
];
export const amazonOrderIdRule = [
  v => requiredCheck(v, "Please enter your Amazon Order Id")
];
export const agreeTermAndConditionRule = [
  v => requiredCheck(v, "You need to agree to our term & condition to proceed")
];
export const productTypeSelectionRule = [
  v => requiredCheck(v, "You need to select a product type to proceed")
];
export const formDetailRule = [
  v => requiredCheck(v, "Please give us some context of your request")
];
export const requestReasonRule = [
  v => requiredCheck(v, "Please specify the reason of your request")
];
export const signInUsernameRule = [
  v => requiredCheck(v, "Required"),
  validateEmail
];
export const signInPasswordRule = [v => requiredCheck(v, "Required")];

export const signUpNameRule = [v => requiredCheck(v, "Required")];
export const signUpUsernameRule = [
  v => requiredCheck(v, "Required"),
  validateEmail
];
export const signUpPasswordRule = [v => requiredCheck(v, "Required")];
